import axios from 'axios'
import qs from 'qs'

const commonApi: any = {}

commonApi.queryPart = (params: {}): Promise<{}> => {
  return axios.post('/v1/api/webcst/partsdata/search/query/word', params)
}
commonApi.queryBulk = (params: {}): Promise<{}> => {
  return axios.get('/v1/api/webcst/car_search_pid/bulk', {params})
}
commonApi.partInfo = (params: {}): Promise<{}> => {
  return axios.get('/v1/api/webcst/basedata/basedata/parts/info', {params})
}
commonApi.fuzzyVin = (params: {}): Promise<{}> => {
  return axios.get('/v1/api/webcst/fuzzy/vin', {params})
}
commonApi.getSearchPart = (params: {}): Promise<{}> => {
  return axios.get('/v1/api/webcst/partsdata/search/query/extend', {params})
}
commonApi.getSearchPartTwo = (params: {}): Promise<{}> => {
  return axios.get('/v1/api/webcst/partsdata/search/query/text', {params})
}
commonApi.getObsSign = (params: {}): Promise<{}> => {
  return axios.post('/v1/api/webcst/post/Signature', params)
}
commonApi.updateObs = (params: {}): Promise<{}> => {
  return axios.post('/v1/api/webcst/CDN/update', params)
}
commonApi.ocrPasteValue = (params: {}): Promise<{}> => {
  return axios.post('/v1/api/webcst/partsdata/search/query/text', params)
}
commonApi.getInventoryParams = (params: {}): Promise<{}> => {
  return axios.get('/v1/api/cstnl/goods/price/show/config', {params})
}

commonApi.translate = (params: {}): Promise<{}> => {
  return axios.post("/v1/api/webcst/translate", params)
}

export default commonApi
